import { useInfiniteQuery } from "@tanstack/react-query"
import { getCatalogue } from "../requests/games"

  export const useGames = ({ queryString, enabled, profileId } : any) => useInfiniteQuery<any>({
    queryKey: ['games', queryString, profileId],
    enabled: enabled,
    initialPageParam: queryString,
    retry: false,
    placeholderData: (prev) => prev,
    queryFn: ({ pageParam }) => getCatalogue(pageParam as string),

    getNextPageParam: (lastPage, _allPages, lastPageParam) => {
      // lastPageParam ES el queryString usado en esta petición
      const params = new URLSearchParams(lastPageParam as string)

      // console.log('GAMES :: LAST PAGE')
      // console.log(lastPage)
      const size = Number(params.get('size')) || 0
      const currentPage = Number(lastPage.page)
      const total = Number(lastPage.total)

      if (!size) return undefined

      const totalPages = Math.ceil(total / size)
    
      if (currentPage + 1 >= totalPages) {
        return undefined
      }

      params.set('page', String(currentPage + 1))

      return params.toString()
    },
  })